import api from './index';
import type { User, UpdateUserRequest } from '@/types/user';

/**
 * Get the current user's profile.
 */
export async function getUser(): Promise<User> {
  const response = await api.get<User>('/users/me');
  return response.data;
}

/**
 * Update the current user's profile.
 */
export async function updateUser(data: UpdateUserRequest): Promise<User> {
  const response = await api.patch<User>('/users/me', data);
  return response.data;
}

/**
 * Delete the current user's account and all associated data.
 * This action is irreversible.
 */
export async function deleteUser(): Promise<void> {
  await api.delete('/users/me');
}
